export const deLanguages = {
	de: '(DE) Deutsch'
};
